import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getStanding } from '../api/gg'
import { useAuth } from '../store/auth'
import { Brand } from '../components/Brand'

interface Standing {
  score: number
  plays: number
  rank: number
}

export function Profile() {
  const user = useAuth((s) => s.user)
  const token = useAuth((s) => s.token)
  const [standing, setStanding] = useState<Standing | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!token) {
      setLoading(false)
      return
    }
    let alive = true
    void getStanding(token)
      .then((s) => { if (alive) setStanding(s) })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [token])

  const goon = user?.displayName || user?.handle || 'GOONER'

  return (
    <main className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-6 flex justify-center">
        <Brand size="lg" />
      </div>

      <div className="cyber-panel p-6">
        <h1 className="goon-title text-4xl text-center mb-1">PROFILE</h1>
        <p className="text-center text-pow tracking-[2px] text-sm mb-6">{goon}</p>

        {!token ? (
          <div className="text-center py-8">
            <p className="text-muted mb-4">Sign in to see your goon stats and multiplier.</p>
            <Link to="/login" className="btn-goon inline-block">SIGN IN</Link>
          </div>
        ) : loading ? (
          <p className="text-center font-comic text-xl text-muted py-8">LOADING SESSION DATA…</p>
        ) : standing ? (
          <div className="grid gap-4 sm:grid-cols-3 text-center">
            <div className="cyber-panel p-4">
              <div className="text-xs uppercase tracking-widest text-muted">BEST SCORE</div>
              <div className="goon-title text-4xl text-kapow mt-1">{standing.score.toLocaleString()}</div>
            </div>
            <div className="cyber-panel p-4">
              <div className="text-xs uppercase tracking-widest text-muted">SESSIONS</div>
              <div className="goon-title text-4xl text-pow mt-1">{standing.plays}</div>
            </div>
            <div className="cyber-panel p-4">
              <div className="text-xs uppercase tracking-widest text-muted">RANK</div>
              <div className="goon-title text-4xl text-zap mt-1">#{standing.rank}</div>
            </div>
          </div>
        ) : (
          <div className="text-center py-6">
            <p className="text-muted">No sessions banked yet.</p>
            <Link to="/play" className="btn-goon mt-4 inline-block">START FIRST SESSION</Link>
          </div>
        )}

        <div className="mt-6 text-xs text-center text-muted">
          Daily return multiplier applies on every signed-in start. Climb the board.
        </div>
      </div>

      <div className="mt-6 flex justify-center gap-3">
        <Link to="/play" className="btn-goon">GOON AGAIN</Link>
        <Link to="/scoreboard" className="btn-ghost">LEADERBOARD</Link>
      </div>
    </main>
  )
}
